function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFinanceInvestment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "finance_x5F_investment",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32.688 32",
    style: {
      enableBackground: "new 0 0 32.688 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 24,
    style: {
      fill: "#FD5C3F"
    },
    width: 3,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD5C3F"
    },
    d: "M20.414,32H0v-5.414L6.586,20H17v1c0,1.125-0.374,2.164-1.002,3h3.588l3.707-3.707 c3.469-3.47,7.964-1.281,8.154-1.188l1.241,0.62L20.414,32z M2,30h17.586l9.551-9.551c-1.205-0.231-2.968-0.204-4.43,1.258 L20.414,26H11v-2h1c1.304,0,2.416-0.836,2.829-2H7.414L2,27.414V30z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 7,
    style: {
      fill: "#FD5C3F"
    },
    width: 16,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD5C3F"
    },
    d: "M12,6c-1.654,0-3-1.346-3-3h2c0,0.552,0.449,1,1,1V6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD5C3F"
    },
    d: "M20,6V4c0.551,0,1-0.448,1-1h2C23,4.654,21.654,6,20,6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD5C3F"
    },
    d: "M15,7h-2c0-0.552-0.449-1-1-1V4C13.654,4,15,5.346,15,7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD5C3F"
    },
    d: "M19,7h-2c0-1.654,1.346-3,3-3v2C19.449,6,19,6.448,19,7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FD5C3F"
    },
    points: "14,14 12,14 12,12.723 15.143,7.485 16.857,8.515 14,13.277  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FD5C3F"
    },
    points: "20,14 18,14 18,13.277 15.143,8.515 16.857,7.485 20,12.723  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD5C3F"
    },
    d: "M25,20.001c0-0.035-0.029-3.616-1.707-5.294l-6-6l1.414-1.414l6,6C26.974,15.56,27,19.819,27,20 L25,20.001z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD5C3F"
    },
    d: "M7,20H5c0-0.181,0.026-4.44,2.293-6.707l6-6l1.414,1.414l-6,6C7.307,16.107,7,19.003,7,20z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 20,
    style: {
      fill: "#FD5C3F"
    },
    width: 2,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FD5C3F"
    },
    points: "23,3 21,3 21,2 11,2 11,3 9,3 9,0 23,0  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinanceInvestment);
export default __webpack_public_path__ + "static/media/finance_investment.7b317d2712df0d3a7a2d6f1c6010fabb.svg";
export { ForwardRef as ReactComponent };